import { render, staticRenderFns } from "./PreviewVideoCall.vue?vue&type=template&id=2af71090&scoped=true"
import script from "./PreviewVideoCall.vue?vue&type=script&lang=js"
export * from "./PreviewVideoCall.vue?vue&type=script&lang=js"
import style0 from "./PreviewVideoCall.vue?vue&type=style&index=0&id=2af71090&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af71090",
  null
  
)

export default component.exports